import { render, staticRenderFns } from "./AxisY2Title.vue?vue&type=template&id=03e49055&scoped=true&"
import script from "./AxisY2Title.vue?vue&type=script&lang=ts&"
export * from "./AxisY2Title.vue?vue&type=script&lang=ts&"
import style0 from "./AxisY2Title.vue?vue&type=style&index=0&id=03e49055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e49055",
  null
  
)

export default component.exports